module.exports = __webpack_public_path__ + "static/media/logoEmilia.d22f770e.png";